import { text } from './text';

const palette = {
  50: '#e2e4ea',
  100: '#b5bccb',
  200: '#8690a8',
  300: '#5a6887',
  400: '#3a4b7a',
  500: '#17305d',
  600: '#112a56',
  700: '#08224c',
  800: '#021a40',
  900: '#00062a',
};

export const navy = {
  ...palette,
  lighter: palette[300],
  light: palette[500],
  main: palette[900],
  dark: palette[900],
  contrastText: text.contrast,
};
